var map = {
	"./01_dept_info_interval.json": "bP1Q",
	"./02_latest_records.json": "cRtg",
	"./03_kline_data.json": "WbRb",
	"./04_quote_ticker.json": "AAve",
	"./05_last_trade_price.json": "lqZR",
	"./06_last_mark_price.json": "zVt3",
	"./07_book_ticker.json": "5TRZ",
	"./08_depth_incr_info.json": "PEl6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vwsV";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/market \.json$
// module id = vwsV
// module chunks = 3